import {
  DeleteOutlined,
  InfoCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { Button, Form, Input, Typography } from 'antd';

import {
  INSTAGRAM_BUTTON_NAME_MAX_LENGTH,
  MAX_INSTAGRAM_BUTTONS_COUNT,
} from '@app/components/Modals/BotDetailsModal/constants/instagramButtons';
import { INSTAGRAM } from '@app/constants';

const { Text } = Typography;

interface InstagramButtonsProps {
  socialType: string | undefined;
}

export const InstagramButtons = ({ socialType }: InstagramButtonsProps) => {
  if (socialType !== INSTAGRAM) {
    return (
      <Text
        type="secondary"
        className="send-message-robot-instagram-buttons-hint"
      >
        <InfoCircleOutlined /> Для канала Instagram доступна отправка кнопок со
        ссылками под текстом сообщения — выберите этот канал, чтобы их
        настроить.
      </Text>
    );
  }

  return (
    <div className="send-message-robot-buttons">
      <Text strong>Кнопки Instagram</Text>
      <Text type="secondary" className="send-message-robot-buttons-hint">
        Кнопки показываются под текстом сообщения в Instagram Direct и открывают
        указанную ссылку. Можно добавить до {MAX_INSTAGRAM_BUTTONS_COUNT}{' '}
        кнопок.
      </Text>

      <Form.List name="buttons">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <div key={key} className="send-message-robot-button-row">
                <div className="item-container">
                  <Text className="label-require">Название кнопки</Text>
                  <Form.Item
                    {...restField}
                    name={[name, 'name']}
                    rules={[
                      {
                        required: true,
                        message: 'Введите название кнопки',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Например, Сайт"
                      maxLength={INSTAGRAM_BUTTON_NAME_MAX_LENGTH}
                    />
                  </Form.Item>
                </div>

                <div className="item-container">
                  <Text className="label-require">Ссылка</Text>
                  <Form.Item
                    {...restField}
                    name={[name, 'url']}
                    rules={[
                      {
                        required: true,
                        message: 'Введите ссылку',
                      },
                      {
                        type: 'url',
                        message: 'Введите корректную ссылку',
                      },
                    ]}
                  >
                    <Input placeholder="https://example.com" />
                  </Form.Item>
                </div>

                <Button
                  type="text"
                  danger
                  aria-label="Удалить кнопку"
                  className="send-message-robot-button-remove"
                  icon={<DeleteOutlined />}
                  onClick={() => remove(name)}
                />
              </div>
            ))}

            {fields.length < MAX_INSTAGRAM_BUTTONS_COUNT && (
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => add()}
              >
                Добавить кнопку Instagram
              </Button>
            )}
          </>
        )}
      </Form.List>
    </div>
  );
};
